import { view } from "@risingstack/react-easy-state";

import type { Product } from "../../common/types/productTypes";

type VariableWeightWarning = {
   product: Product;
};

const VariableWeightWarning = ({ product }: VariableWeightWarning) => {
   if (!product.variableWeight) {
      return null;
   }

   return (
      <p className="tw-mb-3">OBS! Dette produktet har variabel vekt. Vær oppmerksom på at prisen vil bli justert på fakturaen.</p>
   );
};

export default view(VariableWeightWarning);
